import {AvisInitialTypeLight} from './AvisInitialTypeLight';
import { TypeFNSSimpleDescMarche2 } from './TypeFNSSimpleDescMarche2';
export class AttributionFromFNSimple {

	public avisInitial: AvisInitialTypeLight;

	public attributionMarche: string;

	public pasAvisInitial: string;

	public natureMarche: TypeFNSSimpleDescMarche2;

	constructor() {
		this.avisInitial = new AvisInitialTypeLight();
		this.attributionMarche = '';
		this.pasAvisInitial = '';
		this.natureMarche = new TypeFNSSimpleDescMarche2();
	}
}
